import React from "react";
import VideoUpload from "../inputs/video-upload";
import SelectExerciseTypeMuscleGroups from "../inputs/select-exercise-type-muscle-groups";
import {
  EXERCISE_TYPE,
  PRIMARY_MUSCLE_GROUP,
  SECONDARY_MUSCLE_GROUP,
} from "../../constants";

function ExtraInputComponent({
  videoUrl,
  videoFile,
  videoOriginal,
  cleanVideoField,
  handleInputChange,
  exerciseTypeField,
  primaryMuscleGroup,
  secondaryMuscleGroup,
  instructions,
  form,
}) {
  return (
    <>
      <div className="form-row">
        <div className="form-row-item">
          <label>{EXERCISE_TYPE}</label>
          <SelectExerciseTypeMuscleGroups
            value={exerciseTypeField}
            handleChange={handleInputChange}
            type={EXERCISE_TYPE}
            form={form ? form : ""}
          />
        </div>

        <div className="form-row-item">
          <label>{PRIMARY_MUSCLE_GROUP}</label>
          <SelectExerciseTypeMuscleGroups
            value={primaryMuscleGroup}
            handleChange={handleInputChange}
            type={PRIMARY_MUSCLE_GROUP}
            form={form ? form : ""}
          />
        </div>

        <div className="form-row-item">
          <label>{SECONDARY_MUSCLE_GROUP}</label>
          <SelectExerciseTypeMuscleGroups
            value={secondaryMuscleGroup}
            handleChange={handleInputChange}
            type={SECONDARY_MUSCLE_GROUP}
            form={form ? form : ""}
          />
        </div>
      </div>
      <VideoUpload
        videoUrl={videoUrl}
        videoFile={videoFile}
        videoOriginal={videoOriginal}
        cleanVideoField={cleanVideoField}
        handleInputChange={handleInputChange}
        form={form ? form : ""}
      />

      <div className="form-row">
        <div className="form-row-item">
          <label>Instructions</label>
          <textarea
            className="textarea-input"
            name="instructions"
            onChange={handleInputChange}
            value={instructions}
            placeholder="Enter some information for your athletes"
            form={form ? form : ""}
          />
        </div>
      </div>
    </>
  );
}

export default ExtraInputComponent;
